const convertStringToListIfNewLineCharExists
  = (value: string): string[] =>
    value ? value.split("\n").map((item) => item.trim()) : [];

export const stringUtils = {
  convertStringToListIfNewLineCharExists,
};
